export default class NoResultError extends Error {
  constructor(e) {
    super(e || 'Aucun résultat ne correspond à cette recherche.')
    this.name = 'NoResultError'
  }
}
